import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./dashboard/dashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import AboutUs from "./pages/AboutUs";
import CustomerSupport from "./pages/CustomerSupport";
import Blogs from "./blogs/blogs"
import BlogDetails from "./blogs/blog-details/blog-details";
import ContactUs from "./pages/contactUs"; 
import Sitemap from "./sitemap/sitemap";
import MediaScreen from "./pages/media";
import LeadPage from "./pages/LeadPage";
import LeadPageGoogle from "./pages/LeadPageGoogle";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/customer-support" element={<CustomerSupport />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/media" element={<MediaScreen />} />
        <Route path="/blogs/:id" element={<BlogDetails />} />
        <Route path="/sitemap" element={<Sitemap/>}/>
        <Route path="/lead-form" element={<LeadPage/>}/>
        <Route path="/lead-form-google" element={<LeadPageGoogle/>}/>
      </Routes>
    </Router>
  );
}

export default App;
